var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneAppleIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6562 5.06667H26.3438C27.224 5.06667 27.9375 5.78301 27.9375 6.66667V33.3333C27.9375 34.217 27.224 34.9333 26.3438 34.9333H14.6562C13.776 34.9333 13.0625 34.217 13.0625 33.3333V6.66667C13.0625 5.78301 13.776 5.06667 14.6562 5.06667ZM26.3438 4H14.6562C13.1892 4 12 5.19391 12 6.66667V33.3333C12 34.8061 13.1892 36 14.6562 36H26.3438C27.8108 36 29 34.8061 29 33.3333V6.66667C29 5.19391 27.8108 4 26.3438 4ZM14.6562 6.6667H26.3437C26.6371 6.6667 26.875 6.90548 26.875 7.20003V32.8C26.875 33.0946 26.6371 33.3334 26.3437 33.3334H14.6562C14.3628 33.3334 14.125 33.0946 14.125 32.8V7.20003C14.125 6.90548 14.3628 6.6667 14.6562 6.6667ZM26.3437 6.13336H14.6562C14.0694 6.13336 13.5937 6.61093 13.5937 7.20003V32.8C13.5937 33.3891 14.0694 33.8667 14.6562 33.8667H26.3437C26.9305 33.8667 27.4062 33.3891 27.4062 32.8V7.20003C27.4062 6.61092 26.9305 6.13336 26.3437 6.13336Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneAppleIphone);
export default __webpack_public_path__ + "static/media/smartphone-apple-iphone.5a6225e6aaee8c455f094a7eddb4132b.svg";
export { ForwardRef as ReactComponent };